import CrossPromoBanner from './crossPromoBanner'

export default CrossPromoBanner
